import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IWell } from '../shared/components/map/models/wells.inteface';
import { LngLatBounds } from 'mapbox-gl';

@Injectable({
  providedIn: 'root'
})
export class WellsService {

  constructor(private http: HttpClient) { }

  getWellByBounds(bounds: LngLatBounds): Observable<IWell[]>{
    const southwest = bounds.getSouthWest();
    const northeast = bounds.getNorthEast();
    let url = `${environment.url}/crm/dmu`;
    const inBbox = `${northeast.lng},${northeast.lat},${southwest.lng},${southwest.lat}`;
    let params = {
      'in_bbox': inBbox
    }
    return this.http.get<IWell[]>(url,{params});
  }
  search(name: string, limit = 10){
    let url = `${environment.url}/crm/search?name=${name}&limit=${limit}`;
    return this.http.get<any>(url);
  }
}
